console.log("map-config");

var tryjsconfig = {
  tryjs1: {
    hover: "<b><u>Jammu & Kashmir </u><br><b>Fabric: Pashmina    <br><img src='https://cdn.shopify.com/s/files/1/0884/6714/4980/files/aiease_1763449766696.png?v=1763632542' width='100% !important' height='200px !important' ></b>", //info of the popup
    url: "https://sampradayavastra.com/collections/jammu-kashmir", //link to any webpage
    target: "new_window", // use "new_window", "modal", or "none"
    upColor: "#FFFFF3", //default color
    overColor: "#ECFFB3", //highlight color
    downColor: "#cae9af", //clicking color
    bgImage:
      "https://cdn.shopify.com/s/files/1/0884/6714/4980/files/Maharastra.png",
    active: true, //true/false to activate/deactivate
  },
  tryjs2: {
    hover: "<b><u>West Bengal </u><br><b>Fabric: West Bengal    <br><img src='https://cdn.shopify.com/s/files/1/0884/6714/4980/files/west-bengal.png?v=1786538448' width='100% !important' height='200px !important' ></b>",
    url: "https://sampradayavastra.com/collections/west-bangal",
    target: "new_window",
    upColor: "#f1ffc8",
    overColor: "#d9ff66",
    downColor: "#cae9af",
    Image:
      "https://cdn.shopify.com/s/files/1/0884/6714/4980/files/Maharastra.png",
    active: true,
  },
  tryjs3: {
    hover: "<b><u>Uttarakhand</u><br><img src='https://cdn.shopify.com/s/files/1/0884/6714/4980/files/aiease_1763452073160.png?v=1764042990'></b>",
    url: "",
    target: "new_window",
    upColor: "#d7f57a",
    overColor: "#beef2a",
    bgImage:
      "https://cdn.shopify.com/s/files/1/0884/6714/4980/files/Maharastra.png",
    downColor: "#cae9af",
    active: true,
    bgImage:
      "https://cdn.shopify.com/s/files/1/0884/6714/4980/files/aiease_1763199376545_cec5c95b-ccdc-427a-9901-f64bda7d7e1f.png",
  },
  tryjs4: {
    hover: "<b><u>Uttar Pradesh</u></b><br><b>Fabric: Chikankari</b><br><br>Delicate, timeless hand embroidery from Lucknow.<br><br><i>Coming Soon</i>",
    // url: "https://sampradayavastra.com/collections/uttar-pradesh",
    // target: "new_window",
    // upColor: "#f1ffc8",
    // overColor: "#d9ff66",
    // downColor: "#cae9af",
    active: true,
  },
  tryjs5: {
    hover: "Tripurar",
    url: "",
    target: "modal",
    upColor: "#edff66",
    overColor: "#cbe600",
    downColor: "#cae9af",
    active: true,
  },
  tryjs6: {
    hover: "<b><u>Tamil Nadu</u><br><b>Fabric: Kanjeevaram  <br><img src='https://cdn.shopify.com/s/files/1/0884/6714/4980/files/aiease_1763202311519.png?v=1763544475' width='100% !important' height='200px !important' ></b>",
    url: "https://sampradayavastra.com/collections/tamil-nadu",
    target: "new_window",
    upColor: "#edff66",
    overColor: "#cbe600",
    downColor: "#cae9af",
    active: true,
  },
  tryjs7: {
    hover: "<b><u>Telangana</u><br><b>Fabric: Pochampally (Ikat), Gadwal, Narayanapet  <br><img src='https://cdn.shopify.com/s/files/1/0884/6714/4980/files/Telangana.png?v=1765342798' width='100% !important' height='200px !important' ></b>",
    url: "https://sampradayavastra.com/collections/telangana",
    target: "new_window",
    upColor: "#FFFFF3",
    overColor: "#ECFFB3",
    downColor: "#cae9af",
    active: true,
  },
  tryjs8: {
    hover: "Sikkim",
    url: "",
    target: "new_window",
    upColor: "#FFFFF3",
    overColor: "#ECFFB3",
    downColor: "#cae9af",
    active: true,
  },
  tryjs9: {
    hover: "Rajasthan",
    url: "",
    target: "new_window",
    upColor: "#FFFFF3",
    overColor: "#ECFFB3",
    downColor: "#cae9af",
    active: true,
  },
  tryjs10: {
    hover: "Puducherry",
    url: "",
    target: "new_window",
    upColor: "#FFFFF3",
    overColor: "#ECFFB3",
    downColor: "#cae9af",
    active: true,
  },
  tryjs11: {
    hover: "<b><u>Punjab</u></b><br><b>Fabric: Phulkari</b><br><br>Vibrant floral embroidery rooted in Punjabi tradition.<br><br><i>Coming Soon</i>",
    // url: "#",
    // target: "new_window",
    // upColor: "#FFFFF3",
    // overColor: "#ECFFB3",
    // downColor: "#cae9af",
    active: true,
  },
  tryjs12: {
    hover: "<b><u>Odisha</u><br><b>Fabric: Sambalpuri   <br><img src='https://cdn.shopify.com/s/files/1/0884/6714/4980/files/aiease_1763202829383.png?v=1764043460' width='100% !important' height='200px !important' ></b>",
    url: "https://sampradayavastra.com/collections/odisha",
    target: "new_window",
    upColor: "#FFFFF3",
    overColor: "#ECFFB3",
    downColor: "#cae9af",
    active: true,
  },
  tryjs13: {
    hover: "Nagaland",
    url: "",
    target: "new_window",
    upColor: "#FFFFF3",
    overColor: "#ECFFB3",
    downColor: "#cae9af",
    active: true,
  },
  tryjs14: {
    hover: "Mizoram",
    url: "",
    target: "new_window",
    upColor: "#FFFFF3",
    overColor: "#ECFFB3",
    downColor: "#cae9af",
    active: true,
  },
  tryjs15: {
    hover: "<b><u>Madya Pradesh</u><br><b>Fabric: Chanderi<br><img src='https://cdn.shopify.com/s/files/1/0884/6714/4980/files/aiease_1763449139746_d7efe24a-fe53-40c7-8f4c-d16c96e4ec92.png?v=1763630614'></b>",
    url: "https://sampradayavastra.com/collections/madhya-pradesh",
    target: "new_window",
    upColor: "#FFFFF3",
    overColor: "#ECFFB3",
    downColor: "#cae9af",
    active: true,
  },
  tryjs16: {
    hover: "Manipur",
    url: "",
    target: "new_window",
    upColor: "#FFFFF3",
    overColor: "#ECFFB3",
    downColor: "#cae9af",
    active: true,
  },
  tryjs17: {
    hover: "Meghalaya",
    url: "",
    target: "new_window",
    upColor: "#FFFFF3",
    overColor: "#ECFFB3",
    downColor: "#cae9af",
    active: true,
  },
  tryjs18: {
    hover: "<b><u>Maharashtra</u></b><br><b>Fabric: Paithani</b><br><br>Luxurious silk weaves with iconic peacock motifs.<br><br><i>Coming Soon</i>",
    url: "https://sampradayavastra.com/collections/maharashtra",
    target: "new_window",
    upColor: "#FFFFF3",
    overColor: "#ECFFB3",
    downColor: "#cae9af",
    active: true,
  },
  tryjs19: {
    hover: "Lakshadweep",
    url: "",
    target: "new_window",
    upColor: "#FFFFF3",
    overColor: "#ECFFB3",
    downColor: "#cae9af",
    active: true,
  },
  tryjs20: {
    hover: "<b><u>Kerala</u><br><b>Fabric: Kasavu Sarees  <br><img src='https://cdn.shopify.com/s/files/1/0884/6714/4980/files/aiease_1763208369884.png?v=1764041660' width='100% !important' height='200px !important' ></b>",
    url: "https://sampradayavastra.com/collections/kerala",
    target: "new_window",
    upColor: "#FFFFF3",
    overColor: "#ECFFB3",
    downColor: "#cae9af",
    active: true,
  },
  tryjs21: {
    hover: "<b><u>Karnataka</u><br><b>Fabric: Mysore silk      <br><img src='https://cdn.shopify.com/s/files/1/0884/6714/4980/files/aiease_1763448593359.png?v=1764044482'></b>",
    url: "https://sampradayavastra.com/collections/karnataka",
    target: "new_window",
    upColor: "#FFFFF3",
    overColor: "#ECFFB3",
    downColor: "#cae9af",
    active: true,
  },
  tryjs22: {
    hover: "Ladakh",
    url: "",
    target: "new_window",
    upColor: "#FFFFF3",
    overColor: "#ECFFB3",
    downColor: "#cae9af",
    active: true,
  },
  tryjs23: {
    hover: "<b><u> Jharkhand</u><br><b>Fabric: Tussar Silk      <br><img src='https://cdn.shopify.com/s/files/1/0884/6714/4980/files/jharkhand.png?v=1786371142'></b>",
    url: "https://sampradayavastra.com/collections/jharkhand",
    target: "new_window",
    // upColor: "#FFFFF3",
    // overColor: "#ECFFB3",
    // downColor: "#cae9af",
    active: true,
  },
  tryjs24: {
    hover: "Haryana",
    url: "",
    target: "new_window",
    upColor: "#FFFFF3",
    overColor: "#ECFFB3",
    downColor: "#cae9af",
    active: true,
  },
  tryjs25: {
    hover: "Himachal Pradesh",
    url: "",
    target: "new_window",
    upColor: "#FFFFF3",
    overColor: "#ECFFB3",
    downColor: "#cae9af",
    active: true,
  },
  tryjs26: {
    hover: "<b><u>Gujarat</u><br><b>Fabric: Bandhani <br><img src='https://cdn.shopify.com/s/files/1/0884/6714/4980/files/aiease_1763452962612.png?v=1764042280' width='100% !important' height='200px !important' ></b>",
    url: "https://sampradayavastra.com/collections/gujarat-rajasthan",
    target: "new_window",
    // upColor: "#FFFFF3",
    // overColor: "#ECFFB3",
    // downColor: "#cae9af",
    active: true,
  },
  tryjs27: {
    hover: "Goa",
    url: "",
    target: "new_window",
    upColor: "#FFFFF3",
    overColor: "#ECFFB3",
    downColor: "#cae9af",
    active: true,
  },
  tryjs28: {
    hover: "Dadra and Nagar Haveli",
    url: "",
    target: "new_window",
    upColor: "#FFFFF3",
    overColor: "#ECFFB3",
    downColor: "#cae9af",
    active: true,
  },
  tryjs29: {
    hover: "Delhi",
    url: "",
    target: "new_window",
    upColor: "#FFFFF3",
    overColor: "#ECFFB3",
    downColor: "#cae9af",
    active: true,
  },
  tryjs30: {
    hover: "Daman and Diu",
    url: "",
    target: "new_window",
    upColor: "#FFFFF3",
    overColor: "#ECFFB3",
    downColor: "#cae9af",
    active: true,
  },
  tryjs31: {
    hover: "<b><u>Chhattisgarh</u></b><br><b>Fabric: Kosa Silk</b><br><br>Rich Tussar silk known for its natural texture and sheen.<br><br><i>Coming Soon</i>",
    url: "https://sampradayavastra.com/collections/chhattisgarh",
    target: "new_window",
    upColor: "#FFFFF3",
    overColor: "#ECFFB3",
    downColor: "#cae9af",
    active: true,
  },
  tryjs32: {
    hover: "Chandigarh",
    url: "",
    target: "new_window",
    upColor: "#FFFFF3",
    overColor: "#ECFFB3",
    downColor: "#cae9af",
    active: true,
  },
  tryjs33: {
    hover: "<b><u>Bihar</u></b><br><b>Fabric: Bhagalpuri</b><br><br>Rich Tussar silk known for its natural texture and sheen.<br><br><i>Coming Soon</i>",
    url: "https://sampradayavastra.com/collections/bihar",
    target: "new_window",
    upColor: "#FFFFF3",
    overColor: "#ECFFB3",
    downColor: "#cae9af",
    active: true,
  },
  tryjs34: {
    hover: "Assam",
    url: "",
    target: "new_window",
    upColor: "#FFFFF3",
    overColor: "#ECFFB3",
    downColor: "#cae9af",
    active: true,
  },
  tryjs35: {
    hover: "Arunachal Pradesh",
    url: "",
    target: "new_window",
    upColor: "#FFFFF3",
    overColor: "#ECFFB3",
    downColor: "#cae9af",
    active: true,
  },
  tryjs36: {
    hover: "<b><u>Andhra Pradesh</u><br><b>Fabric: Kalamkari, Mangalagiri, Kuppadam, Uppada <br><img src='https://cdn.shopify.com/s/files/1/0884/6714/4980/files/Ap.png?v=1765342798' width='100% !important' height='200px !important' ></b>",
    url: "https://sampradayavastra.com/collections/andhra-pradesh",
    target: "new_window",
    upColor: "#FFFFF3",
    overColor: "#ECFFB3",
    downColor: "#cae9af",
    active: true,
  },
  tryjs37: {
    hover: "Andaman and Nicobar Islands",
    url: "",
    target: "new_window",
    upColor: "#FFFFF3",
    overColor: "#ECFFB3",
    downColor: "#cae9af",
    active: true,
  },

  general: {
    borderColor: "#9CA8B6",
    visibleNames: "#adadad",
  },
};
